import { protectedAxiosInstance } from "./axiosManagement";

export const getBriefList = (params) => {
  return protectedAxiosInstance
    .get("/admin/briefs", { params })
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};

export const getBriefDetails = (id, params) => {
  return protectedAxiosInstance
    .get(`/admin/briefs/${id}`, { params })
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};

export const reviewBrief = (id, payload) => {
  // payload: { status: "APPROVED" } or { status: "REJECTED", admin_comment: "..." }
  // Approve runs the WhatsApp broadcast synchronously server-side, so cap the
  // request — a slow/hung broadcast shouldn't freeze the admin UI. On timeout
  // the caller re-fetches the brief, which reflects the committed approval.
  return protectedAxiosInstance
    .post(`/admin/briefs/${id}/review`, payload, { timeout: 30000 })
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
